import { template } from "@ember/template-compiler";
import styles from '@hokulea/core/windows.module.css';
import type { TOC } from '@ember/component/template-only';
export interface PopoverSignature {
    Element: HTMLDivElement;
    Blocks: {
        default: [];
    };
}
const Popover: TOC<PopoverSignature> = template(`
  <div class={{styles.popover}} data-test-popover ...attributes>
    {{yield}}
  </div>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
export default Popover;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL2hva3VsZWEvaG9rdWxlYS9lbWJlci9wYWNrYWdlL3NyYy9jb21wb25lbnRzL3BvcG92ZXIuZ3RzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZXMgZnJvbSAnQGhva3VsZWEvY29yZS93aW5kb3dzLm1vZHVsZS5jc3MnO1xuXG5pbXBvcnQgdHlwZSB7IFRPQyB9IGZyb20gJ0BlbWJlci9jb21wb25lbnQvdGVtcGxhdGUtb25seSc7XG5cbmV4cG9ydCBpbnRlcmZhY2UgUG9wb3ZlclNpZ25hdHVyZSB7XG4gIEVsZW1lbnQ6IEhUTUxEaXZFbGVtZW50O1xuICBCbG9ja3M6IHtcbiAgICBkZWZhdWx0OiBbXTtcbiAgfTtcbn1cblxuY29uc3QgUG9wb3ZlcjogVE9DPFBvcG92ZXJTaWduYXR1cmU-ID0gPHRlbXBsYXRlPlxuICA8ZGl2IGNsYXNzPXt7c3R5bGVzLnBvcG92ZXJ9fSBkYXRhLXRlc3QtcG9wb3ZlciAuLi5hdHRyaWJ1dGVzPlxuICAgIHt7eWllbGR9fVxuICA8L2Rpdj5cbjwvdGVtcGxhdGU-O1xuXG5leHBvcnQgZGVmYXVsdCBQb3BvdmVyO1xuIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQSxPQUFPLFlBQVksbUNBQW1DO0FBRXRELGNBQWMsR0FBRyxRQUFRLGlDQUFpQztBQUUxRCxpQkFBaUI7SUFDZixTQUFTO0lBQ1Q7UUFDRTs7O0FBSUosTUFBTSxTQUFTLElBQUksb0JBQW9CLFNBQVUsQ0FBQTs7OztBQUlqRCxDQUFBLEVBQUE7SUFBQTtRQUFBLE9BQUEsS0FBQSxTQUFBLENBQUEsRUFBVztJQUFEO0FBQUE7QUFFVixlQUFlLFFBQVEifQ